import { RequestType } from "types/business/RequestType";
import { BehaviorSubject } from "types/libReplace/BehaviorSubject";
import { createUseDefaultObservable } from "utils/libExtend/createUseDefaultObservable";

type CurrentType = RequestType;

export const useDefaultObservableRequestType = createUseDefaultObservable<CurrentType>();

export class BehaviorSubjectRequestType extends BehaviorSubject<CurrentType> {}
